import { render, staticRenderFns } from "./BlockEditor.vue?vue&type=template&id=40e60157&scoped=true&"
import script from "./BlockEditor.vue?vue&type=script&lang=js&"
export * from "./BlockEditor.vue?vue&type=script&lang=js&"
import style0 from "./BlockEditor.vue?vue&type=style&index=0&id=40e60157&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e60157",
  null
  
)

export default component.exports